module.exports = [{"oid":"","name":""},{"oid":"FL","name":"FL"},{"oid":"IF","name":"IF"},{"oid":"LC","name":"LC"},{"oid":"VVS","name":"VVS"},{"oid":"VS","name":"VS"},{"oid":"SI","name":"SI"},{"oid":"I","name":"I"},{"oid":"P","name":"P"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/ZJD.json
// module id = kbu9
// module chunks = 1